import { render } from "./SmartFormSummarySection.vue?vue&type=template&id=92455676&ts=true"
import script from "./SmartFormSummarySection.vue?vue&type=script&lang=ts"
export * from "./SmartFormSummarySection.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__